import { render, staticRenderFns } from "./QualificationTypeList.vue?vue&type=template&id=599f1852"
import script from "./QualificationTypeList.js?vue&type=script&lang=js&external"
export * from "./QualificationTypeList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports